import { verifyCompany } from '@/api/v4/organization.api';
import { useMutation } from '@tanstack/react-query';

export const useVerifyCompanyMutation = () => {
  return useMutation({
    mutationFn: verifyCompany,
  });
};
